<app-loader *ngIf="isDisabled"></app-loader>
<form name="ResignationReasonForm" (ngSubmit)="Validate(ResignationReasonForm)" #ResignationReasonForm="ngForm">
    <div class="card">
        <div class="card-header">
            Resignation Reason
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12 px-2">
                    <label>Resignation Reason Name</label>
                    <input type="text" class="form-control mt-1" [(ngModel)]="filter.Name"
                        name="ResignationReason" placeholder="Ex. Name" required>
                    <div class="invalid-feedback fs-7">
                        Please enter Resignation Reason Name !
                    </div>
                </div>
                <div class="col-md-12 px-2 mt-2">
                    <div class="d-flex align-items-center">
                        <label for="checkbox" class="me-2 mb-0 text-label-dark">Active</label>
                        <input type="checkbox" class="form-check-input" id="checkbox" name="checkbox"
                            [(ngModel)]="filter.Active" />
                    </div>

                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">
                </div>
                <div class="col-auto">
                    <button type="button" class="btn btn-outline-primary btn-sm me-1" ngbTooltip="Cancel"
                        container="body" placement="top" (click)="close()" [disabled]="isDisabled">
                        Cancel
                        <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                            aria-hidden="true"></span>
                    </button>

                    <!-- <button
                        *ngIf="(this.id == 0 && this.common.PageRight.IsAdd) || (this.id > 0 && this.common.PageRight.IsEdit)"
                        type="submit" class="btn btn-primary btn-sm" [disabled]="isDisabled"><i class="bi bi-save2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button> -->

                    <button type="submit" class="btn btn-primary btn-sm" [disabled]="isDisabled"><i class="bi bi-save2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Save':'Loading...'}}</button>
                </div>
            </div>
        </div>

    </div>
</form>